export const DASHBOARD_GRAPH_IDS = [
  'revenue',
  'payroll',
  'clientBills',
  'employeePayslips',
] as const;

export type DashboardGraphId = (typeof DASHBOARD_GRAPH_IDS)[number];

const GRAPH_ID_SET = new Set<string>(DASHBOARD_GRAPH_IDS);

export function dashboardGraphStorageKey(companyId: string): string {
  return `bill-alps-dashboard-graphs:${companyId}`;
}

export function parseStoredGraphSelection(
  storedValue: string | null,
): DashboardGraphId[] {
  if (storedValue === null) return [...DASHBOARD_GRAPH_IDS];

  try {
    const parsed: unknown = JSON.parse(storedValue);
    if (!Array.isArray(parsed)) return [...DASHBOARD_GRAPH_IDS];

    return [...new Set(parsed)].filter(
      (value): value is DashboardGraphId =>
        typeof value === 'string' && GRAPH_ID_SET.has(value),
    );
  } catch {
    return [...DASHBOARD_GRAPH_IDS];
  }
}
